import StudentAdministratorScreen from './containers/studentAdministratorScreen'

export {default as StudentAdministratorScreenLayout} from './components/studentAdministratorScreenLayout'

export default StudentAdministratorScreen
